module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp23_5012.6fbc4704.png";